import React, { Component } from 'react';
import Recaptcha from 'react-google-invisible-recaptcha';
import Cookies from 'universal-cookie';
import MediaKit from '../../MediaKit';
import isMobile from 'react-device-detect';

let recaptchaInstanceContact;
const cookies = new Cookies();

export default class SignUpSplash extends Component {
	constructor(props) {
		super(props);
		this.state = { 
			value: '',
			firstName: '',
			isFirstNameValid: false,
			isFirstNameFocused: false,
			lastName: '',
			isLastNameValid: false,
			isLastNameFocused: false,
			email: '',
			isEmailValid: false,
            isEmailChecked: '',
			isEmailFocused: false,
			isSubmitDisabled: 'disabled',
            displayBtnLoader: false,
            submitResponse: '',
            submitResponseColor: '',
			regexMatcher: new RegExp(/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/),
			clientip: '',
			deviceType: 0
		 };
		this.handleChange = this.handleChange.bind(this);
		this.handleFocus = this.handleFocus.bind(this);
		this.handleClick = this.handleClick.bind(this);
		//this.handleSubmit = this.handleSubmit.bind(this);
		
		this.verifyCallback = this.verifyCallback.bind(this);
		this.executeCaptcha = this.executeCaptcha.bind(this);		

	}

	//setCookie
	setCookie() {
		let d = new Date();        
		//d.setTime(d.getTime() + (120));
		d.setDate(d.getDate() + 30); //pastVK message to futureVK setDate() is a mutator soooo the plus adds days maybe AddDays???! 

		//console.log(stringData);
		// Maybe we can use this to pass parameters of splash screen
		// Cookie values using this.state
		// let cookieValue = {accepted: 'Accepted', signupFirstName: this.state.firstName, signupLastName: this.state.lastName, signupEmail: this.state.email};
		// cookies.set('C_S', cookieValue, { path: '/', expires: d });

		/*const arr = Array.from // if available
  ? Array.from(encryptedStr.tag) // use Array#from
  : [].map.call(encryptedStr.tag, (v => v)); // otherwise map()
// now stringify
const str = JSON.stringify(arr);*/

		cookies.set('C_S', 'Accepted', { path: '/', expires: d });

		/*const retrievedArr = JSON.parse(cookies.get('C_S'));
const retrievedTypedArray = new Uint8Array(retrievedArr);
console.log(retrievedTypedArray.byteLength);*/

		this.setState({ renderSite: <MediaKit /> });
	}

	// manually trigger reCAPTCHA execution
    executeCaptcha() {
        this.setState({
            submitResponseColor: ' yellow',
            submitResponse: 'Submitting, please wait...',
            displayBtnLoader: true
        });
        recaptchaInstanceContact.execute();
    }

	// executed once the captcha has been verified
    // can be used to post forms, redirect, etc.
    verifyCallback() {
        //let form = document.getElementById("form") as HTMLFormElement
        //form.submit(); 
		//event.preventDefault();
		fetch("https://api.ipify.org?format=json")
		.then(response => {return response.json();}, "jsonp")
		.then(res => {
		  //this.setState({clientip: res.ip})
		  this.handleIP(res)
		  //console.log(res.ip)	
		  })
		.catch(err => console.log(err));
	  
		//console.log(this.state.clientip);		
		// uncomment when ready to send data         
    }

	handleIP(res){
		//this.setState({clientip: res.ip})
		//console.log(this.state.clientip);		
		const deviceType = isMobile ? 1 : 2;
		this.setState({ deviceType: deviceType });
		//console.log(this.state.deviceType);
		
		const requestBody = {
			Email: this.state.email,
			Firstname: this.state.firstName,
			Lastname: this.state.lastName,
			Clientip: res.ip,
			DeviceTypeId: deviceType,
			GRecaptchaResponse: recaptchaInstanceContact.getResponse()
		};
		
		fetch('https://www.couponology.com/api/email/addsplashemail/', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
				'Accept': 'application/json'
			},
			body: JSON.stringify(requestBody)
		})
		.then(response => response.status)
		.catch(error => console.error('Error:', error))
		.then(response => this.handleResponse(response));
	}

	handleChange(event){
		let newState = {};
        newState[event.target.name] = event.target.value;
		this.setState(newState);
		
		if (event.target.name === 'firstName') {
            this.setState({ isFirstNameValid: event.target.value.length > 0 ? true : false });
		}
		
		if (event.target.name === 'lastName') {
            this.setState({ isLastNameValid: event.target.value.length > 0 ? true : false });
		}
		
		if (event.target.name === 'email') {
            this.setState({ isEmailChecked: event.target.value.match(this.state.regexMatcher) ? 'glyphicon glyphicon-ok green' : 'glyphicon glyphicon-remove red' });
            this.setState({ isEmailValid: event.target.value.match(this.state.regexMatcher) ? true : false });
		}
		
		this.setState({ isSubmitDisabled: (this.state.isFirstNameValid && this.state.isLastNameValid && this.state.isEmailValid) ? '' : 'disabled' });
	}

	handleFocus(event) {
		if (event.target.name === 'firstName') {
            this.setState({ isFirstNameFocused: true });
		}
		
		if (event.target.name === 'lastName') {
            this.setState({ isLastNameFocused: true });
        }

        if (event.target.name === 'email') {
            this.setState({ isEmailFocused: true });
		}
		
		if (event.target.id === 'submit_overlay') {
			this.setState({ isFirstNameFocused: true });
			this.setState({ isLastNameFocused: true });
            this.setState({ isEmailFocused: true });
        }
        this.setState({ submitResponse: '' });
	}

	handleClick(e) {
        this.handleFocus(e);
	}
	
	/*handleSubmit(event) {
        event.preventDefault();
        fetch('api/Email/contactUs?email=' + this.state.email + '&firstName=' + this.state.firstName + '&lastName=' + this.state.lastName).then(response => response.json())
            .catch(error => console.error('Error:', error))
            .then(response => this.handleResponse(response));
	}*/
	
	handleResponse(response) {
        recaptchaInstanceContact.reset();
        if (response === 200) {			
			this.setCookie();
			localStorage.setItem('firstaname',this.state.firstName);
			localStorage.setItem('lastname',this.state.lastName);
			localStorage.setItem('email',this.state.email);
            this.setState({
                submitResponseColor: ' green',
                submitResponse: 'Your message has been sent. Thank you!',
                displayBtnLoader: false
            });
        }
		else if (response === 406){
            this.setState({
                submitResponseColor: ' red',
                submitResponse: 'This is an invalid email. Please try again.',
                displayBtnLoader: false
            });
        }
        else {
            this.setState({
                submitResponseColor: ' red',
                submitResponse: 'An error has occurred. Please try again.',
                displayBtnLoader: false
            });
        }
    }

	renderSite() {		
		return (
			<div className='signup-splash-container'>
				<div className='inner-content'>
					<div className='logo'>
						<img src='https://cdn.couponology.com/images/couponology-logo-transp-M.png' alt='Couponology logo' />
					</div>
					<div className='row'>
						<div className='col-md-12 input-container text-center'>
							<input required name='firstName' type='text' placeholder='First Name' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.firstName} />
							<span className={this.state.firstName.length > 0 || !this.state.isFirstNameFocused ? 'visibility-hidden message' : 'required-message message'}>This field is required</span>
						</div>
						<div className='col-md-12 input-container text-center'>
							<input required name='lastName' type='text' placeholder='Last Name' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.lastName} />
							<span className={this.state.lastName.length > 0 || !this.state.isLastNameFocused ? 'visibility-hidden message' : 'required-message message'}>This field is required</span>
						</div>
						<div className='col-md-12 input-container text-center'>
							<input required name='email' type='text' placeholder='Email' onChange={this.handleChange} onKeyUp={this.handleChange} onFocus={this.handleFocus} value={this.state.email} />
							<span className='email-validation-message'><i className={this.state.isEmailChecked}></i></span>
                            <span className={(this.state.email.length > 0 && this.state.isEmailValid) || !this.state.isEmailFocused ? 'visibility-hidden message' : 'required-message message'}>Please enter a valid email</span>
						</div>
					</div>
					<div className='btn-container'>
                        {this.state.displayBtnLoader ?
                            <button className='contact-submit-btn' disabled={true}>
                                <span className='btn-loader'></span>
                            </button> :
                            <button className='contact-submit-btn' onClick={this.executeCaptcha} disabled={this.state.isSubmitDisabled}>
                                <span className='glyphicon glyphicon-log-in' aria-hidden="true"></span>Enter Site
                            </button>}
                        <div className={this.state.isSubmitDisabled === 'disabled' ? 'overlay' : 'display-none overlay'} onClick={this.handleClick} id='submit_overlay'></div>
                    </div>
					<div className='badge-container'>
                        <Recaptcha
                            ref={e => recaptchaInstanceContact = e}
                            sitekey="6LeTFnEUAAAAALfsaxcWZ9PF5d7tbv1zpayebpYB"
                            onResolved={this.verifyCallback}
                            badge="inline"
                        />
                    </div>
					<p className={'email-submit-response' + this.state.submitResponseColor}>{this.state.submitResponse}</p>
				</div>
			</div>
		);
	}

	render() {
		if (!cookies.get('C_S')) {
			let site;
			site = this.renderSite();
			return (
				<div>
					{site}
				</div>
			);
		} else {
			return (
				<div>
					<MediaKit />
				</div>
			);
		}	
	}

}